// const dashboard = resolve => require(['../dashboard.vue'], resolve);
export default [{
        meta: {
            requiresAuth: true
        },
        name: 'MallTrainList',
        path: '/mall/train/list',
        component: resolve => require(['./list.vue'], resolve),
    },
    {
        meta: {
            requiresAuth: true
        },
        path: '/order/train/Change/:UniqueID?',
        name: 'ChangeTicket',
        component: resolve => require(['./policy/ChangeTicket.vue'], resolve)
    },
    {
        meta: {
            requiresAuth: true
        },
        path: '/train/refundTicket',
        name: 'refundTicket',
        component: resolve => require(['./policy/refundTicket.vue'], resolve)
    },
    {
        meta: {
            requiresAuth: true
        },
        path: '/order/orderSeat',
        name: 'orderSeat',
        component: resolve => require(['./orderSeat.vue'], resolve)
    },

    // , {
    //     name: 'TrainOrder',
    //     path: '/mall/train/order',
    //     component: resolve => require(['./order.vue'], resolve)
    // }
]



// WEBPACK FOOTER //
// ./src/views/mall/train/router.js